// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-1pKbJlPR","dbox":"dbox-3yr-JOvG"};